<header class="col-12 header-page">
    <h1 class="header__page__content__title">
        PDV - Programa de Demissão Voluntária
    </h1>
    <div class="col-sm-12 col-md-5 col-xl-5 px-1">
        <a type="button" [routerLink]="['/minhas-solicitacoes-pdv']"
            class="btn btn-outline-primary btn-outline-primary-historico float-right">
            <span>Minhas Solicitações</span>
        </a>
    </div>
</header>
<ng-template #showLoading>
    <spinner [show]="true"></spinner>
</ng-template>
<main class="col-12 main__content" *ngIf="loading; else showLoading">
    <blockquote class="mt-2 main-content-blockquote">
        <b>Bem-vindo ao espaço exclusivo para quem aderiu ao PDV (Programa de Demissão Voluntária).</b>
        <br>
        Aqui, você poderá encaminhar todos os documentos e formulários necessários de forma prática e rápida.
        <br>
        Antes de iniciar o processo, você pode simular o benefício com as tabelas progressiva ou regressiva para
        escolher a melhor opção para sua situação. <a [routerLink]="['/simulador-previdencia']">Acesse aqui</a>
        <br>
        Ao se desligar da patrocinadora, é essencial solicitar a aposentadoria ou optar por um dos institutos assim que
        possuir a homologação da rescisão de contrato de trabalho. Para tornar esse processo mais ágil, recomendamos que
        você organize e preencha tudo antecipadamente aqui no portal. Posteriormente, validaremos seu desligamento junto
        à patrocinadora.
        <br>
        Neste espaço, você poderá preencher todos os formulários necessários, tanto de previdência quanto de saúde, sem
        a necessidade de comparecer à Fundação Copel.
        <br>
        Vamos começar? Preencha os formulários, anexe os documentos e, se tiver dúvidas, estaremos à disposição para
        ajudá-lo sempre que precisar.
    </blockquote>
    <div class="col-12 aviso-solicitacao-negada" *ngIf="base && base?.lastSolicitationStatus == 'Negado' ">
        A sua última solicitação foi Negada, acesse o link: <a [routerLink]="['/minhas-solicitacoes-pdv']">Minhas
            Solicitações</a> para mais informações.
    </div>
    <ng-template #solicitacaoAndamento>
        <section class="content-aviso-solicitado">
            <p>
                Solicitação recebida!
            </p>
            <div>
                O Status da sua solicitação é <b>{{base?.lastSolicitationStatus.split(' ')[0]}}</b>
            </div>
            <a (click)="cancelarSolicitacao()">
                clique aqui para cancelar sua solicitação
            </a>
        </section>
    </ng-template>
    <section
        *ngIf="(base && base?.lastSolicitationStatus == '' || base && base?.lastSolicitationStatus == 'Negado' || base && base?.lastSolicitationStatus == 'Cancelado' || base && base?.lastSolicitationStatus == null) else solicitacaoAndamento || loadAfterRequired">
        <mat-vertical-stepper [linear]="true" #stepper (selectionChange)="onStepChange($event)">
            <mat-step [stepControl]="formContact" id="dados-pessoais" [editable]="true">
                <ng-template matStepLabel>Meus Dados</ng-template>
                <div class="subtitle-form">
                    <h6>Dados Pessoais</h6>
                    <duvida
                        [textoAviso]="'Para alterar os seus dados pessoais, você precisa acessar a tela de Dados Cadastrais.'" />
                </div>
                <form [formGroup]="meusDados">
                    <section class="row mt-3 px-0">
                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 mb-3 px-1">
                            <label class="label-form">Nome</label>
                            <input class="form-control input-form" formControlName="name" [attr.disabled]="true"
                                maxlength="70" placeholder="Nome Completo">
                        </div>
                        <div class="col-xl-3 col-lg-4 col-md-4 col-sm-12 mb-3 px-1">
                            <label class="label-form">N° da Matrícula</label>
                            <input class="form-control input-form" formControlName="registration" placeholder="XXX.XXX"
                                [attr.disabled]="true">
                        </div>
                        <div class="col-xl-3 col-lg-4 col-md-4 col-sm-12 mb-3 px-1">
                            <label class="label-form">CPF</label>
                            <input class="form-control input-form" formControlName="cpf" placeholder="XXX.XXX.XXX-XX"
                                mask="XXX.XXX.XXX-XX" [attr.disabled]="true">
                        </div>
                    </section>
                </form>
                <br>
                <div class="subtitle-form">
                    <h6>Endereço</h6>
                    <duvida [textoAviso]="'Para solicitar a alteração de endereço.'" />
                </div>
                <form [formGroup]="formContact">
                    <div class="form-body row">
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">
                                CEP
                            </label>
                            <input class="form-control input-form" formControlName="cep" maxlength="9" mask="00000-000"
                                placeholder="XXXXX-XXX" (input)="cepChanged()" (keyup)="inputChanged()">
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.get('cep')?.touched && !formContact.controls['cep'].valid" [@fadeIn]>
                                Não foi encontrado o CEP informado
                            </small>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">Endereço</label>
                            <input class="form-control input-form" formControlName="address" maxlength="70">
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.get('address')?.touched && formContact.get('address')?.invalid">
                                O campo Endereço é obrigatório!
                            </small>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">Número</label>
                            <input class="form-control input-form" formControlName="number" maxlength="5"
                                autocomplete="off">
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.get('number')?.touched && formContact.get('number')?.invalid">
                                O campo Número é obrigatório!
                            </small>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">Complemento</label>
                            <input class="form-control input-form" formControlName="complement" maxlength="70"
                                autocomplete="off">
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">Bairro</label>
                            <input class="form-control input-form" formControlName="district" maxlength="40">
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.get('district')?.touched && formContact.get('district')?.invalid">
                                O campo Bairro é obrigatório!
                            </small>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">Caixa Postal</label>
                            <input class="form-control input-form" formControlName="postalCode" maxlength="70"
                                autocomplete="off" type="number">
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">Município</label>
                            <input class="form-control input-form" formControlName="city">
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.get('city')?.touched && formContact.get('city')?.invalid">
                                O campo Município é obrigatório!
                            </small>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">UF</label>
                            <input class="form-control input-form" formControlName="state" placeholder="Ex: XX">
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.get('state')?.touched && formContact.get('state')?.invalid">
                                O campo UF é obrigatório!
                            </small>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">País</label>
                            <input class="form-control input-form" formControlName="country">
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.get('country')?.touched && formContact.get('country')?.invalid">
                                O campo País é obrigatório!
                            </small>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">Telefone Celular</label>
                            <input class="form-control input-form" formControlName="personalPhone"
                                placeholder='(DDD) 9XXXX-XXXX' mask="(XX) XXXXX-XXXX">
                            <span class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.get('personalPhone')?.touched && formContact.get('personalPhone')?.invalid">
                                Informe um número de telefone válido
                            </span>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">Telefone Comercial/Residencial</label>
                            <input class="form-control input-form" formControlName="comercialPhone"
                                placeholder="(XX) XXXX-XXXX" mask="(XX) XXXX-XXXX">
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">E-mail</label>
                            <input class="form-control input-form" formControlName="email"
                                placeholder="xxxxxxx@xxxx.com">
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.get('email')?.touched && formContact.controls['email'].invalid && !formContact.controls['email'].hasError('invalidEmailPdv')"
                                [@fadeInOut]>
                                E-mail inválido!
                            </small>
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.controls['email'].hasError('invalidEmailPdv')" [@fadeInOut]>
                                Por favor, informe um e-mail pessoal, não corporativo!
                            </small>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-3 px-1">
                            <label class="label-form">E-mail Alternativo</label>
                            <input class="form-control input-form" formControlName="secondaryEmail"
                                placeholder="xxxxxxx@xxxx.com">
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.get('secondaryEmail')?.touched && formContact.controls['secondaryEmail'].invalid && !formContact.controls['secondaryEmail'].hasError('invalidEmailPdv')"
                                [@fadeInOut]>
                                E-mail inválido!
                            </small>
                            <small class="form-text text-muted danger ng-star-inserted"
                                *ngIf="formContact.controls['secondaryEmail'].hasError('invalidEmailPdv') "
                                [@fadeInOut]>
                                Por favor, informe um e-mail pessoal, não corporativo!
                            </small>
                        </div>
                    </div>
                    <div class="form-check form-check-inline col-12 py-1"
                        *ngIf="beneficiaries && beneficiaries.length > 0 && formChanged">
                        <input formControlName="replicateDependant" class="form-check-input" type="checkbox"
                            id="inlineCheckbox1" value="option1">
                        <label class="form-check-label label-form" for="inlineCheckbox1">Incluir alteração de
                            endereço para dependentes</label>
                    </div>
                    <div class="form-check form-check-inline col-12 py-3">
                        <input class="form-check-input" type="checkbox" id="check-box-meus-dados" value="true"
                            formControlName="aceitesContato" (click)="showValues()">
                        <label class="form-check-label label-form" for="check-box-meus-dados">Concordo</label>
                    </div>
                </form>
                <div class="content-stepper-buttons">
                    <button class="btn btn-primary" mat-button matStepperNext
                        [disabled]="!formContact.valid || formContact.get('aceitesContato')?.value == false">Próximo</button>
                </div>
            </mat-step>
            <mat-step id="dados-bancarios" [stepControl]="formDadosBancarios" [click.prevent]="true">
                <form [formGroup]="formDadosBancarios">
                    <ng-template matStepLabel>Dados Bancários</ng-template>
                    <ng-template #naoPossuiDadosBancarios>
                        <section class="content-dados-bancarios" style="font-size: 0.875rem !important;">
                            <div class="nao-possui-dados-bancarios">
                                <p style="color: #D25401; font-weight: 500;">Você não possui dados bancários em nossa
                                    base de dados!</p>
                                <p>Por gentileza faça o anexo de um documento bancário para prosseguir com a
                                    solicitação!</p>
                            </div>
                            <div class="row col-10 px-0">
                                <a class="link-dadosBancarios" (click)="alterarDadosBancarios()">
                                    Alterar dados bancários
                                </a>
                            </div>
                        </section>
                    </ng-template>
                    <section *ngIf="dataBanco else naoPossuiDadosBancarios">
                        <section class="content-dados-bancarios">
                            <div class="row" *ngIf="dataBanco">
                                <div class="px-0 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                    <span>Nome do Banco:</span>
                                    <span>{{dataBanco?.banco}} - {{dataBanco?.bancoDescricao}}</span>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                    <span>Número da Conta:</span>
                                    <span>{{dataBanco?.conta}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="px-0 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                    <span>Tipo de Conta:</span>
                                    <span>{{dataBanco?.tipo_Conta}}</span>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                    <span>Número da Agência:</span>
                                    <span>{{dataBanco?.agencia}}</span>
                                </div>
                            </div>
                            <div class="row px-0 col-12">
                                <a class="link-dadosBancarios" (click)="alterarDadosBancarios()">
                                    Alterar dados bancários
                                </a>
                            </div>
                        </section>
                    </section>
                    <section class="col-xl-12 p-0 content-form-lista" *ngIf="listaDocumentos.length > 0">
                        <!-- <div class="lista-row" *ngFor="let file of formDadosBancarios.get('documentos.file')?.value; let i = index"> -->
                        <div class="lista-row" *ngFor="let file of listaDocumentos; let i = index">
                            <span>
                                {{file.fileName}}
                            </span>
                            <div class="lista-actions">
                                <fa-icon class="card__header__icon lista-btn-close" size="2x" (click)="removeFile(i)"
                                    [icon]="faSquareXmark">
                                </fa-icon>
                            </div>
                        </div>
                    </section>
                    <div class="form-check form-check-inline col-12 py-3">
                        <input class="form-check-input" type="checkbox" id="check-box-dados-bancarios" value="true"
                            formControlName="aceitesDadosBancarios">
                        <label class="form-check-label label-form" for="check-box-dados-bancarios">Concordo</label>
                    </div>
                </form>
                <div class="content-stepper-buttons">
                    <button class="btn btn-outline-primary" mat-button matStepperPrevious>Voltar</button>
                    <button class="btn btn-primary" mat-button matStepperNext
                        [disabled]="(!formDadosBancarios.valid && this.dataBanco != null) || (this.dataBanco == null && listaDocumentos.length == 0)">Próximo</button>
                </div>
            </mat-step>
            <mat-step [stepControl]="formDependentesIr" id="dependentes-ir">
                <ng-template matStepLabel>Dependentes do IR</ng-template>
                <form [formGroup]="formDependentesIr">
                    <ng-template #naoPossuiDependentes>
                        <p>Você não possui dependentes de Previdência</p>
                        <div class="form-check form-check-inline col-12 py-3">
                            <input class="form-check-input" type="checkbox" id="check-box-dependentes-ir" value="true"
                                formControlName="aceitesIr">
                            <label class="form-check-label label-form" for="check-box-dependentes-ir">Concordo</label>
                        </div>
                    </ng-template>
                    <section
                        *ngIf="listDependentePrevidenciario && listDependentePrevidenciario.length > 0 else naoPossuiDependentes">
                        <p style="font-size: 0.875rem; margin-bottom: 1rem;">
                            Por favor selecione os seus dependentes do Imposto de Renda
                        </p>
                        <section class="content__main__table">
                            <!-- <section class="content__header__table">
                                <div class="col-1"></div>
                                <div class="col-5">Nome</div>
                                <div class="col-3">Grau de Parentesco</div>
                                <div class="col-3">Condição de Vida</div>
                            </section> -->
                            <section class="table__card"
                                *ngFor="let dependente of listDependentePrevidenciario; let i = index">
                                <div class="col-1">
                                    <div class="form-check text-center">
                                        <input class="position-static" name="carteirinhas" value="{{dependente.cpf}}"
                                            type="checkbox" (click)="adicionarDependenteIr(dependente)">
                                    </div>
                                </div>
                                <div class="col-6">{{dependente.name}}</div>
                                <div class="col-5">{{dependente.familyType}}</div>
                            </section>
                        </section>
                        <div class="form-check form-check-inline col-12 py-3">
                            <input class="form-check-input" type="checkbox" id="check-box-dependentes-ir" value="true"
                                formControlName="aceitesIr">
                            <label class="form-check-label label-form" for="check-box-dependentes-ir">Concordo</label>
                        </div>
                    </section>
                </form>
                <div class="content-stepper-buttons">
                    <button class="btn btn-outline-primary" mat-button matStepperPrevious>Voltar</button>
                    <button class="btn btn-primary" mat-button matStepperNext
                        [disabled]="!formDependentesIr.valid">Próximo</button>
                </div>
            </mat-step>
            <mat-step [stepControl]="formInstituido" id="instituto">
                <ng-template matStepLabel>Aposentadoria ou Institutos</ng-template>
                <form class="form-instituto" [formGroup]="formInstituido">
                    <p class="mb-3" style="font-size: 0.875rem;">
                        Você pertence ao Plano <b>{{planoSelecionado?.planName}}</b>
                    </p>
                    <section class="content-instituto"
                        *ngIf="canceladoCapitalizacao == false && base.pessoa.cpf != '78529280997' ">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="exampleRadios" id="aposentado" value="1"
                                formControlName="instituido" (click)="resetInstituto()">
                            <label class="form-check-label" for="aposentado">
                                Aposentadoria
                            </label>
                        </div>
                        <blockquote class="descricao-radio">
                            Para fazer jus ao benefício de aposentadoria <b>{{healthProfile}}</b>, o participante deverá
                            contar com pelo menos 45 anos de idade, ter no mínimo 05 anos de filiação ao plano, ter
                            rescindido o vínculo empregatício com a patrocinadora e o valor inicial do benefício atingir
                            02 UPs (atual R$ 1.065,24). Caso seja do Plano Unificado, é necessário ter rescindido o
                            vínculo empregatício com a patrocinadora e estar aposentado pelo INSS.
                            <br>
                            A fim de manter a continuidade do benefício solicitado acima, assumo o compromisso de
                            atualizar minhas informações cadastrais anualmente até 31 de março ou quando da ocorrência
                            de qualquer alteração, comunicando imediatamente À FC.
                            Estou ciente que a análise de pagamento é apenas por meio eletrônico, disponível na área
                            restrita do participante no site da Fundação Copel.
                            Autorizo a Fundação Copel a descontar eventuais débitos de todo e quaisquer créditos a que
                            fizer jus, inclusive, sobre o abono anual/13º salário.
                        </blockquote>
                    </section>
                    <section *ngIf="canceladoCapitalizacao == false">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="exampleRadios" id="autopatrocinio"
                                value="10" formControlName="instituido" (click)="resetInstituto()">
                            <label class="form-check-label" for="autopatrocinio">
                                Autopatrocínio
                            </label>
                        </div>
                        <blockquote class="descricao-radio">
                            Opção para o participante, que tenha seu contrato rescindido ou licenciado sem remuneração,
                            de manter- se filiado ao
                            {{socialSecurityProfile}}, desde que continue contribuindo de acordo com o plano de custeio
                            (contribuição normal e administrativa
                            obrigatória e contribuição adicional de risco facultativa).
                        </blockquote>
                    </section>
                    <section
                        *ngIf="profile?.hasBpdPermission && canceladoCapitalizacao == false && base.pessoa.cpf != '78529280997'">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="exampleRadios" id="bpd" value="11"
                                formControlName="instituido" (click)="resetInstituto()">
                            <label class="form-check-label" for="bpd">
                                Benefício Proporcional Diferido - (BPD)
                            </label>
                        </div>
                        <blockquote class="descricao-radio">
                            Opção para o participante com mais de 3 (três) anos ininterruptos de contribuição ao Plano,
                            e que não tenha preenchido
                            os pré-requisitos regulamentares para solicitação do benefício de aposentadoria, desde que
                            continue contribuindo de
                            acordo com o plano de custeio (contribuição administrativa obrigatória e contribuição
                            adicional de risco facultativa) e
                            mantenha-se filiado ao {{socialSecurityProfile}}.
                        </blockquote>
                    </section>
                    <section
                        *ngIf="profile?.hasBpdPermission && canceladoCapitalizacao == false && base.pessoa.cpf != '78529280997' ">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="exampleRadios" id="bpu" value="16"
                                formControlName="instituido" (click)="resetInstituto()">
                            <label class="form-check-label" for="bpu">
                                Benefício de pagamento único (BPU)
                            </label>
                        </div>
                        <blockquote class="descricao-radio">
                            BPU – Para solicitar o benefício de aposentadoria vitalícia do plano III, o participante tem
                            que preencher estes 4 requisitos:
                            <ol
                                style="list-style: auto; margin-left: 1.5rem; margin-top: 0.25rem; margin-bottom: 0.25rem;">
                                <li>Ter se desligado da patrocinadora;</li>
                                <li>Ter pelo menos 45 anos de idade;</li>
                                <li>Ter pelo menos 5 anos de contribuição ao plano, e;</li>
                                <li>Ter uma reserva que pague pelo menos um benefício de 2 Unidades Previdenciárias
                                    (UP), hoje equivalente a R$ 1.065,24.</li>
                            </ol>
                            Caso o participante tenha preenchido os 3 primeiros requisitos, mas não tenha ainda a
                            reserva para pagamento do benefício mínimo de 2 UPs, neste caso, E NESTE CASO SOMENTE, o
                            Regulamento prevê a possibilidade do Benefício de Pagamento Único (BPU), que consiste no
                            pagamento, em uma única parcela, do total das contribuições feitas pelo participante mais as
                            contribuições feitas pela Patrocinadora em seu nome.
                        </blockquote>
                    </section>
                    <section *ngIf="base.pessoa.cpf != '78529280997' ">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="exampleRadios" id="portabilidadeIntegral"
                                value="12" formControlName="instituido" (click)="resetInstituto()">
                            <label class="form-check-label" for="portabilidadeIntegral">
                                Portabilidade Integral
                            </label>
                        </div>
                        <blockquote class="descricao-radio">
                            Opção para o participante com mais de 3 (três) anos ininterruptos de contribuição ao Plano,
                            de realizar a transferência do
                            valor de suas contribuições normais para outro plano de previdência complementar, desde que
                            seja na modalidade
                            tributária semelhante ao PGBL. A portabilidade integral implica na cessação de qualquer
                            compromisso do plano com o
                            participante. Para realizar a portabilidade, será necessário o preenchimento do Termo de
                            Portabilidade.
                        </blockquote>
                    </section>
                    <section *ngIf="canceladoCapitalizacao == false && base.pessoa.cpf != '78529280997' ">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="exampleRadios" id="portabilidadeParcial"
                                value="13" formControlName="instituido" (click)="resetInstituto()">
                            <label class="form-check-label" for="portabilidadeParcial">
                                Portabilidade Parcial
                            </label>
                        </div>
                        <blockquote class="descricao-radio">
                            Opção de realizar a transferência de valores oriundos de portabilidades trazidas para este
                            plano de EFPCs (somente a
                            parte referente às contribuições do participante), EAPCs ou Seguradoras e/ou contribuições
                            facultativas e aportes
                            efetuadas pelo próprio participante, para outro plano de previdência complementar, desde que
                            seja na modalidade
                            tributária semelhante ao PGBL. Para realizar a portabilidade parcial, será necessário o
                            preenchimento do Termo de
                            Portabilidade.
                            <!-- <b class="descricao-radio-bold">(Para este instituto, não é necessária a cessação do vínculo empregatício com a Patrocinadora)</b> -->
                        </blockquote>
                    </section>
                    <section *ngIf="base.pessoa.cpf != '78529280997'">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="exampleRadios" id="resgateIntegral"
                                value="14" formControlName="instituido" (click)="resetInstituto()">
                            <label class="form-check-label" for="resgateIntegral">
                                Resgate Integral
                            </label>
                        </div>
                        <blockquote class="descricao-radio">
                            Opção de realizar o resgate do valor de suas contribuições para o
                            <b>{{socialSecurityProfile}}</b>. O resgate integral implica na cessação de
                            qualquer compromisso do plano com o participante. O pagamento do resgate está condicionado,
                            conforme
                            Regulamento, a uma carência de <b>90 (noventa)</b> dias úteis da data de seu protocolo junto
                            à Fundação Copel. O participante
                            pode, a seu critério, solicitar o pagamento do resgate em até <b>12 (doze) parcelas</b>.
                        </blockquote>
                    </section>
                    <section *ngIf="canceladoCapitalizacao == false && base.pessoa.cpf != '78529280997'">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" name="exampleRadios" id="resgateParcial"
                                value="15" formControlName="instituido" (click)="resetInstituto()">
                            <label class="form-check-label" for="resgateParcial">
                                Resgate Parcial
                            </label>
                        </div>
                        <blockquote class="descricao-radio">
                            Opção de realizar o resgate de valores oriundos de portabilidades trazidas para este plano
                            de EAPCs, Seguradoras e
                            EFPCs (somente a parte referente às contribuições do participante) e/ou contribuições
                            facultativas e aportes efetuadas
                            pelo próprio participante.
                            <!-- <b class="descricao-radio-bold">(Para este instituto, não é necessária a cessação do vínculo empregatício com a Patrocinadora)</b> -->
                        </blockquote>
                    </section>
                    <div class="form-check form-check-inline col-12 py-3">
                        <input class="form-check-input" type="checkbox" id="check-box-instituto" value="true"
                            formControlName="aceiteInstituido">
                        <label class="form-check-label label-form" for="check-box-instituto">Concordo</label>
                    </div>
                </form>
                <!-- <div>
                <button mat-button matStepperPrevious>Back</button>
                <button mat-button (click)="stepper.reset()">Reset</button>
              </div> -->
                <div class="content-stepper-buttons">
                    <button class="btn btn-outline-primary" mat-button matStepperPrevious>Voltar</button>
                    <button class="btn btn-primary" mat-button matStepperNext
                        [disabled]="!formInstituido.valid">Próximo</button>
                </div>
            </mat-step>
            <mat-step [stepControl]="formDocumentos" id="formularioInstituto">
                <ng-template matStepLabel>Instituto Selecionado</ng-template>
                <form [formGroup]="formDocumentos">
                    <section>
                        <section class="formularioInstituto-content"
                            *ngIf="formInstituido.get('instituido')?.value == 10">
                            <p class="titulo-instituto-selecionado">Com relação às contribuições como
                                <b>autopatrocinado</b>.
                            </p>
                            <p class="mt-3 mb-2">Benefício de Risco</p>
                            <section class="formularioInstituto-content-checkbox">
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="autopatrocinado-form"
                                        id="autopatrocinado-form-true" value="true" formControlName="adicionalBeneficio"
                                        (click)="adicionarRisco(1)">
                                    <label class="form-check-label" for="autopatrocinado-form-true">
                                        Desejo incluir adicional de benefício de risco
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="autopatrocinado-form"
                                        id="autopatrocinado-form-false" value="false"
                                        formControlName="adicionalBeneficio" (click)="adicionarRisco(2)">
                                    <label class="form-check-label" for="autopatrocinado-form-false">
                                        Não desejo incluir adicional de benefício de risco
                                    </label>
                                </div>
                            </section>
                            <p class="mt-3 mb-2" *ngIf="possuiPeculio == true">Tenho interesse em permanecer com o Plano
                                Pecúlio</p>
                            <section class="row formularioInstituto-content-checkbox" *ngIf="possuiPeculio == true">
                                <div class="form-check mr-2">
                                    <input class="form-check-input" type="radio" name="permanecer-form"
                                        id="permanecer-form-true" value="true" formControlName="interessePermanencia">
                                    <label class="form-check-label" for="permanecer-form-true">
                                        Sim
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="permanecer-form"
                                        id="permanecer-form-false" value="false" formControlName="interessePermanencia">
                                    <label class="form-check-label" for="permanecer-form-false">
                                        Não
                                    </label>
                                </div>
                            </section>
                            <!-- <div class="row">
                                <p class="titulo-instituto-selecionado">Contribuição mínima normal baseada nos <b>{{(this.base?.plano?.porcentagemOpcional | number:'1.0-2') + '%' }}</b> no valor mensal de <b>{{mediaSalarial | currency:'BRL':'symbol':'1.2-2':'pt'}}</b></p>                                
                            </div> -->
                            <ol class="px-1 taxas-beneficios">
                                <li>Benefício de Risco (duas partes) é igual a <b>{{beneficioRisco |
                                        currency:'BRL':'symbol':'1.2-2':'pt'}}</b> </li>
                                <li>Taxa Administrativa (duas partes) é igual a <b>{{taxaAdministrativa |
                                        currency:'BRL':'symbol':'1.2-2':'pt'}}</b> </li>
                                <li>
                                    O valor mínimo da contribuição normal não pode ser inferior a <b>25% (
                                        {{mediaSalarial | currency:'BRL':'symbol':'1.2-2':'pt'}} )</b> do valor da
                                    contribuição enquanto ativo.
                                </li>
                            </ol>
                            <div class="col-xl-4 col-md-6 col-sm-12 mt-2 px-1"
                                *ngIf="formDocumentos.get('adicionalBeneficio')?.value == 'false' || formDocumentos.get('adicionalBeneficio')?.value == 'true' "
                                [@fadeIn]>
                                <label class="label-form">Contribuição normal mensal <span
                                        class="label__form__required">*</span></label>
                                <input class="form-control input-form" placeholder="R$ 0,00"
                                    formControlName="contribuicaoNormalMensal" maxlength="14"
                                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" currencyMask />
                                <small class="form-text text-muted danger" style="display: flex; gap: 0.25rem;"
                                    *ngIf="formDocumentos.get('contribuicaoNormalMensal')?.touched && formDocumentos.get('contribuicaoNormalMensal')?.invalid"
                                    [@fadeIn]>
                                    O valor informado deve ser maior ou igual de {{mediaSalarial |
                                    currency:'BRL':'symbol':'1.2-2':'pt'}}
                                </small>
                            </div>
                            <div class="row mt-1">
                                <p class="mt-1 titulo-instituto-selecionado"
                                    *ngIf="formDocumentos.get('adicionalBeneficio')?.value == 'true' && !formDocumentos.get('contribuicaoNormalMensal')?.invalid"
                                    [@fadeIn]>
                                    Sendo assim o total do boleto é de:
                                    <b>{{(formDocumentos.controls.contribuicaoNormalMensal.value + beneficioRisco +
                                        taxaAdministrativa) | currency:'BRL':'symbol':'1.2-2':'pt'}}</b>
                                </p>
                                <p class="mt-1 titulo-instituto-selecionado mt-1"
                                    *ngIf="formDocumentos.get('adicionalBeneficio')?.value == 'false' && !formDocumentos.get('contribuicaoNormalMensal')?.invalid"
                                    [@fadeIn]>
                                    Sendo assim o total do boleto é de:
                                    <b>{{(formDocumentos.controls.contribuicaoNormalMensal.value + taxaAdministrativa) |
                                        currency:'BRL':'symbol':'1.2-2':'pt'}}</b>
                                </p>
                            </div>
                            <div class="form-check form-check-inline col-12 py-3">
                                <input class="form-check-input" type="checkbox" name="check-box-instituto-selecionado"
                                    id="check-box-instituto-selecionado" value="true" formControlName="aceite">
                                <label class="form-check-label label-form"
                                    for="check-box-instituto-selecionado">Concordo</label>
                            </div>
                        </section>
                        <section class="formularioInstituto-content"
                            *ngIf="formInstituido.get('instituido')?.value == 11">
                            <p class="titulo-instituto-selecionado">Com relação às contribuições do <b>BPD</b>, opto
                                por:</p>
                            <section class="formularioInstituto-content-checkbox">
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="form-bpd"
                                        id="autopatrocinado-form-true" value="true"
                                        formControlName="adicionalBeneficio">
                                    <label class="form-check-label" for="autopatrocinado-form-true">
                                        Desejo incluir adicional de benefício de risco
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="form-bpd"
                                        id="autopatrocinado-form-false" value="false"
                                        formControlName="adicionalBeneficio">
                                    <label class="form-check-label" for="autopatrocinado-form-false">
                                        Não desejo incluir adicional de benefício de risco
                                    </label>
                                </div>
                            </section>
                            <ol class="px-1 taxas-beneficios">
                                <li>Benefício de Risco (duas partes) é igual a {{beneficioRisco |
                                    currency:'BRL':'symbol':'1.2-2':'pt'}}</li>
                                <li>Taxa Administrativa (duas partes) é igual a {{taxaAdministrativa |
                                    currency:'BRL':'symbol':'1.2-2':'pt'}}</li>
                            </ol>
                            <p *ngIf="formDocumentos.get('adicionalBeneficio')?.value == 'true' ">
                                <b>Sendo assim o Total do boleto é de: {{ (beneficioRisco + taxaAdministrativa) |
                                    currency:'BRL':'symbol':'1.2-2':'pt' }}</b>
                            </p>
                            <p *ngIf="formDocumentos.get('adicionalBeneficio')?.value == 'false' ">
                                <b>Sendo assim o Total do boleto é de: {{ (taxaAdministrativa) |
                                    currency:'BRL':'symbol':'1.2-2':'pt' }}</b>
                            </p>
                            <p class="mt-3 mb-2" *ngIf="possuiPeculio == true">Tenho interesse em permanecer com o Plano
                                Pecúlio</p>
                            <section class="row formularioInstituto-content-checkbox" *ngIf="possuiPeculio == true">
                                <div class="form-check mr-2">
                                    <input class="form-check-input" type="radio" name="form-permanecer-peculio"
                                        id="permanecer-form-true" value="true" formControlName="interessePermanencia">
                                    <label class="form-check-label" for="permanecer-form-true">
                                        Sim
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="form-permanecer-peculio"
                                        id="permanecer-form-false" value="false" formControlName="interessePermanencia">
                                    <label class="form-check-label" for="permanecer-form-false">
                                        Não
                                    </label>
                                </div>
                            </section>
                            <br />
                            <p class="mt-2">
                                <b>Obs.:</b> O salário base para cálculo de prêmio e capital segurado será reajustado
                                anualmente, no mesmo índice de acordo coletivo de sua patrocinadora.
                            </p>
                            <div class="form-check form-check-inline col-12 py-3">
                                <input class="form-check-input" type="checkbox" id="check-box-instituto-selecionado"
                                    value="true" formControlName="aceite">
                                <label class="form-check-label label-form"
                                    for="check-box-instituto-selecionado">Concordo</label>
                            </div>
                        </section>
                        <section class="formularioInstituto-content"
                            *ngIf="formInstituido.get('instituido')?.value == 16">
                            <!-- <p class="titulo-instituto-selecionado"> Desejo realizar a <b>Benefício de pagamento único (BPU)</b>: </p> -->
                            <b style="font-size: 0.875rem;">Formulário de solicitação</b>
                            <section class="row">
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 px-2">
                                    <form-input
                                        [errorRequired]="(formDocumentos.get('documentoRg.file')?.touched && formDocumentos.get('documentoRg.file')?.value == null)"
                                        [labelInput]="'Cópia do RG '" [isMultiple]="false" [isRequired]="true"
                                        [tipoDocumento]="'rg'" (adicionar)="adicionarArquivos('documentoRg',$event)">
                                    </form-input>
                                    <section class="col-xl-12 p-0 content-form-lista">
                                        <div class="lista-row"
                                            *ngFor="let itemFile of formDocumentos.get('documentoRg.file')?.value; let i = index"
                                            [@fadeIn]>
                                            <span>
                                                {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                                            </span>
                                            <div class="lista-actions">
                                                <fa-icon class="card__header__icon lista-btn-close" size="2x"
                                                    (click)="removeFileDocument('documentoRg',i)"
                                                    [icon]="faSquareXmark">
                                                </fa-icon>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 px-2">
                                    <form-input
                                        [errorRequired]="(formDocumentos.get('documentoCpf.file')?.touched && formDocumentos.get('documentoCpf.file')?.value == null)"
                                        [labelInput]="'Cópia do CPF '" [isMultiple]="false" [isRequired]="true"
                                        [tipoDocumento]="'cpf'" (adicionar)="adicionarArquivos('documentoCpf',$event)">
                                    </form-input>
                                    <section class="col-xl-12 p-0 content-form-lista">
                                        <div class="lista-row"
                                            *ngFor="let itemFile of formDocumentos.get('documentoCpf.file')?.value; let i = index"
                                            [@fadeIn]>
                                            <span>
                                                {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                                            </span>
                                            <div class="lista-actions">
                                                <fa-icon class="card__header__icon lista-btn-close" size="2x"
                                                    (click)="removeFileDocument('documentoCpf',i)"
                                                    [icon]="faSquareXmark">
                                                </fa-icon>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </section>
                            <ol class="px-1 taxas-beneficios" style="font-size: 0.875rem;">
                                <li>Valores baseados na Tributação Progressiva: <b>{{
                                        resgateReserva.total_Liquido_Progressivo | currency:'BRL':'symbol':'1.2-2':'pt'
                                        }}</b> </li>
                                <li>Valores baseados na Tributação Regressiva: <b>{{
                                        resgateReserva.total_Liquido_Regressivo | currency:'BRL':'symbol':'1.2-2':'pt'
                                        }}</b> </li>
                            </ol>
                            <p class="col-12 px-1" style="color: #D25401; font-weight: 500; margin-top: 0.25rem;">
                                O valor líquido poderá ser alterado caso tenha débitos com a previdência, saúde e
                                empréstimo.
                            </p>
                            <h5 class="mt-3" style="width: 100%;text-align: center;">Anexo 01</h5>
                            <section class="content__aviso__artigo">
                                <div class="content-progressiva">
                                    <h5>Opção pela Tabela Regressiva para a Progressiva</h5>
                                    <blockquote>
                                        Destacamos que a opção pela forma de tributação da Tabela Progressiva não
                                        implica somente nos valores descontados do Benefício de Pagamento Único (BPU),
                                        mas ela produz também efeitos no que tange à declaração anual de Imposto de
                                        Renda.
                                        <br>
                                        Listamos abaixo pontos que merecem sua atenção:
                                    </blockquote>
                                    <div class="enumerated-list">
                                        <p>
                                            Os valores recebidos pela Tabela Progressiva são rendas tributáveis e devem
                                            ser informados na sua declaração anual de IR e se somarão às demais rendas
                                            tributáveis mensais, quando então será calculado o valor real do IR
                                        </p>
                                        <p>
                                            Sendo mais uma renda tributável, há possibilidade de lançamento de deduções
                                            como saúde, previdência, e educação sobre essa renda;
                                        </p>
                                    </div>
                                </div>
                                <div class="content-regressiva">
                                    <h5>Opção pela Tabela Progressiva para a Regressiva</h5>
                                    <blockquote class="main-content-blockquote">
                                        Destacamos que a opção pela forma de tributação para a Tabela Regressiva não
                                        implica somente nos valores descontados do do Benefício de Pagamento Único
                                        (BPU), mas ela produz também efeitos no que tange à declaração anual de Imposto
                                        de Renda.
                                        <br>
                                        Listamos abaixo pontos que merecem sua atenção:
                                    </blockquote>
                                    <div class="enumerated-list">
                                        <p>
                                            Os valores recebidos pela Tabela Regressiva possuem tributação definitiva,
                                            ou seja, exclusiva na fonte e aparecerão apenas pelo valor líquido em seu
                                            informe de rendimentos
                                        </p>
                                        <p>
                                            Os valores devem ser declarados como renda já tributada e não compõem mais
                                            sua renda anual tributável na declaração de Imposto de Renda.
                                            Não sendo mais uma tributável, não há possibilidade de lançamento de
                                            deduções como saúde, previdência e educação sobre essa renda;
                                        </p>
                                        <p>
                                            As eventuais deduções, na declaração de imposto de renda, poderão ser
                                            efetuadas somente nos valores recebidos pelo INSS e outras fontes de renda;
                                        </p>
                                    </div>
                                </div>
                            </section>
                            <section class="row formularioInstituto-content-checkbox">
                                <div class="form-check mr-2">
                                    <input class="form-check-input" type="radio" name="exampleRadios"
                                        id="tributacao-regressiva-integral-true" value="Progressiva"
                                        formControlName="tributacao">
                                    <label class="form-check-label" for="tributacao-regressiva-integral-true">
                                        Tributação pela tabela <b>Progressiva</b>
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="exampleRadios"
                                        id="tributacao-regressiva-integral-false" value="Regressiva"
                                        formControlName="tributacao">
                                    <label class="form-check-label" for="tributacao-regressiva-integral-false">
                                        Tributação pela tabela <b>Regressiva</b>
                                    </label>
                                </div>
                            </section>
                            <!-- <p id="resultado-bpu">
                                <span *ngIf="formDocumentos.get('tributacao')?.value == 'Progressiva' ">Valores baseados na Tributação Progressiva: {{ resgateReserva.total_Liquido_Progressivo | currency:'BRL':'symbol':'1.2-2':'pt' }}</span>
                                <span *ngIf="formDocumentos.get('tributacao')?.value == 'Regressiva' ">Valores baseados na Tributação Regressiva: {{ resgateReserva.Regressivo | currency:'BRL':'symbol':'1.2-2':'pt' }}</span>
                            </p> -->
                            <div class="form-check form-check-inline col-12 py-3">
                                <input class="form-check-input" type="checkbox" id="check-box-instituto-selecionado"
                                    value="true" formControlName="aceite">
                                <label class="form-check-label label-form"
                                    for="check-box-instituto-selecionado">Concordo</label>
                            </div>
                        </section>
                        <section *ngIf="formInstituido.get('instituido')?.value == 12">
                            <p class="titulo-instituto-selecionado">Instituto selecionado Portabilidade Integral</p>
                            <div class="form-check form-check-inline col-12 py-3">
                                <input class="form-check-input" type="checkbox" id="check-box-instituto-selecionado"
                                    value="true" formControlName="aceite">
                                <label class="form-check-label label-form"
                                    for="check-box-instituto-selecionado">Concordo</label>
                            </div>
                        </section>
                        <section class="formularioInstituto-content"
                            *ngIf="formInstituido.get('instituido')?.value == 13">
                            <p class="titulo-instituto-selecionado">Desejo realizar a <b>Portabilidade Parcial</b> dos
                                seguintes valores:</p>
                            <ol class="px-1 taxas-beneficios">
                                <li>
                                    Valor de contribuições extras e aportes: <b>{{ (ContributionHistory +
                                        AdditionalContribution) | currency:'BRL'}}</b>
                                </li>
                                <li>
                                    Opção selecionada contribuições facultativas e ou aportes
                                </li>
                            </ol>
                            <section style="display: grid; margin-top: 0.5rem; gap:0.25rem">
                            </section>
                            <div class="col-xl-4 col-md-6 col-sm-12 mt-0 px-0">
                                <label class="label-form">Informe o valor desejado <span
                                        class="label__form__required">*</span></label>
                                <input class="form-control input-form" placeholder="R$ 0,00"
                                    formControlName="valorSolicitadoPortabilidadeParcial" maxlength="14"
                                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" currencyMask />
                                <small class="form-text text-muted danger "
                                    *ngIf="formDocumentos.get('valorSolicitadoPortabilidadeParcial')?.touched && formDocumentos.get('valorSolicitadoPortabilidadeParcial')?.invalid"
                                    [@fadeIn]>
                                    O valor informado deve ser de até <b>{{ (ContributionHistory +
                                        AdditionalContribution) | currency:'BRL'}}</b>
                                </small>
                            </div>
                            <div class="form-check form-check-inline col-12 py-3">
                                <input class="form-check-input" type="checkbox" id="check-box-instituto-selecionado"
                                    value="true" formControlName="aceite">
                                <label class="form-check-label label-form"
                                    for="check-box-instituto-selecionado">Concordo</label>
                            </div>
                        </section>
                        <section class="formularioInstituto-content"
                            *ngIf="formInstituido.get('instituido')?.value == 14">
                            <p class="mb-3 titulo-instituto-selecionado">Desejo realizar o <b>Resgate Integral</b>:</p>
                            <section class="row formularioInstituto-content-checkbox">
                                <div class="form-check mr-2">
                                    <input class="form-check-input" type="radio" name="parcela-form"
                                        id="permanecer-form-true" value="1" formControlName="quantidadeParcelas"
                                        (click)="resetValor('parcelaUnica')">
                                    <label class="form-check-label" for="permanecer-form-true">
                                        Em parcela única
                                    </label>
                                </div>
                                <div class="form-check" #containerSelect>
                                    <!-- <input class="form-check-input" type="radio" name="parcela-form" id="permanecer-form-false" value="permanecer-form-false" (click)="resetValor('parcelado')"> -->
                                    <label class="container-select" [ngClass]="(parceladoBoolean) ? 'selected' : null ">
                                        <p for="permanecer-form-false">Parcelado em até </p>
                                        <ng-select [items]="listaValores" (change)="changeQuantidadeParcelas($event)"
                                            [clearable]="false" bindLabel="label" bindValue="valor" class="ng-pristine"
                                            id="ngSelect" #ngSelect />
                                        <p for="permanecer-form-false">vezes</p>
                                    </label>
                                </div>
                            </section>
                            <ol class="px-1 taxas-beneficios">
                                <li>Resgate (Tabela Progressiva): {{ reserva.total_Liquido_Progressivo |
                                    currency:'BRL'}}</li>
                                <li>Resgate (Tabela Regressiva): {{ reserva.total_Liquido_Regressivo | currency:'BRL'}}
                                </li>
                            </ol>
                        </section>
                        <section class="formularioInstituto-content"
                            *ngIf="formInstituido.get('instituido')?.value == 15">
                            <p class="mb-3 titulo-instituto-selecionado">Desejo realizar o <b>Resgate Parcial</b> dos
                                seguintes valores:</p>
                            <!-- <ol class="px-1 taxas-beneficios">
                                <li>Resgate (Tabela Progressiva): {{ reserva.total_Liquido_Progressivo | currency:'BRL'}}</li>
                                <li>Resgate (Tabela Regressiva): {{ reserva.total_Liquido_Regressivo | currency:'BRL'}}</li>
                            </ol> -->
                            <section style="display: grid; margin-top: 0.5rem;">
                                <!-- <div class="form-check mr-2 mt-2">
                                    <input class="form-check-input" type="radio" name="radio-form" id="resgate-parcial-epac" value="EAPC" formControlName="portabilidadeOuResgateParcial">
                                    <label class="form-check-label" for="resgate-parcial-epac">
                                        Portabilidade oriunda de EAPC trazida para o (tipo-plano)
                                    </label>
                                </div>
                                <div class="form-check mr-2 mt-2">
                                    <input class="form-check-input" type="radio" name="radio-form" id="resgate-parcial-efpc" value="EFPC" formControlName="portabilidadeOuResgateParcial">
                                    <label class="form-check-label" for="resgate-parcial-efpc">
                                        Portabilidade oriunda de EFPC (somente parte do participante) trazida para o (tipo-plano)
                                    </label>
                                </div> -->
                                <!-- <div class="form-check mr-2 mt-2">
                                    <input class="form-check-input" type="radio" name="radio-form" id="contribuicoes-facultativas-aportes" value="FacultativasEOuAportes" formControlName="portabilidadeOuResgateParcial">
                                    <label class="form-check-label" for="contribuicoes-facultativas-aportes">
                                        Contribuições facultativas e ou aportes
                                    </label>
                                </div> -->
                            </section>
                            <ol class="px-1 taxas-beneficios">
                                <li>
                                    Valor de contribuições extras e aportes:<b>{{ (ContributionHistory +
                                        AdditionalContribution) | currency:'BRL'}}</b>
                                </li>
                                <li>
                                    Opção selecionada contribuições facultativas e ou aportes
                                </li>
                            </ol>
                            <!-- <p style="font-size: 0.875rem !important; font-weight: 500; margin-top: 0.5rem;">Valor total: R$XX,XX</p> -->
                            <div class="col-xl-4 col-md-6 col-sm-12 mt-0 px-0">
                                <label class="label-form">Informe o valor desejado <span
                                        class="label__form__required">*</span></label>
                                <input class="form-control input-form" placeholder="R$ 0,00"
                                    formControlName="valorSolicitadoPortabilidadeParcial" maxlength="14"
                                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }" currencyMask />
                                <small class="form-text text-muted danger "
                                    *ngIf="formDocumentos.get('valorSolicitadoPortabilidadeParcial')?.touched && formDocumentos.get('valorSolicitadoPortabilidadeParcial')?.invalid"
                                    [@fadeIn]>
                                    O valor informado deve ser de até <b>{{ (ContributionHistory +
                                        AdditionalContribution) | currency:'BRL'}}</b>
                                </small>
                            </div>
                        </section>
                    </section>
                    <section *ngIf="formInstituido.get('instituido')?.value == 1">
                        <b style="font-size: 0.875rem;">Formulário de solicitação</b>
                        <section class="row">
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 px-2">
                                <form-input
                                    [errorRequired]="(formDocumentos.get('documentoRg.file')?.touched && formDocumentos.get('documentoRg.file')?.value == null)"
                                    [labelInput]="'Cópia do RG '" [isMultiple]="false" [isRequired]="true"
                                    [tipoDocumento]="'rg'" (adicionar)="adicionarArquivos('documentoRg',$event)">
                                </form-input>
                                <section class="col-xl-12 p-0 content-form-lista">
                                    <div class="lista-row"
                                        *ngFor="let itemFile of formDocumentos.get('documentoRg.file')?.value; let i = index"
                                        [@fadeIn]>
                                        <span>
                                            {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                                        </span>
                                        <div class="lista-actions">
                                            <fa-icon class="card__header__icon lista-btn-close" size="2x"
                                                (click)="removeFileDocument('documentoRg',i)" [icon]="faSquareXmark">
                                            </fa-icon>
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 px-2">
                                <form-input
                                    [errorRequired]="(formDocumentos.get('documentoCpf.file')?.touched && formDocumentos.get('documentoCpf.file')?.value == null)"
                                    [labelInput]="'Cópia do CPF '" [isMultiple]="false" [isRequired]="true"
                                    [tipoDocumento]="'cpf'" (adicionar)="adicionarArquivos('documentoCpf',$event)">
                                </form-input>
                                <section class="col-xl-12 p-0 content-form-lista">
                                    <div class="lista-row"
                                        *ngFor="let itemFile of formDocumentos.get('documentoCpf.file')?.value; let i = index"
                                        [@fadeIn]>
                                        <span>
                                            {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                                        </span>
                                        <div class="lista-actions">
                                            <fa-icon class="card__header__icon lista-btn-close" size="2x"
                                                (click)="removeFileDocument('documentoCpf',i)" [icon]="faSquareXmark">
                                            </fa-icon>
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 px-2">
                                <form-input
                                    [errorRequired]="(formDocumentos.get('documentoRescisao.file')?.touched && formDocumentos.get('documentoRescisao.file')?.value == null)"
                                    [labelInput]="'Cópia da homologação da rescisão do contrato ou baixa na carteira digital ou física'"
                                    [isMultiple]="false" [isRequired]="true" [tipoDocumento]="'rescisao'"
                                    (adicionar)="adicionarArquivos('documentoRescisao',$event)">
                                </form-input>
                                <section class="col-xl-12 p-0 content-form-lista">
                                    <div class="lista-row"
                                        *ngFor="let itemFile of formDocumentos.get('documentoRescisao.file')?.value; let i = index"
                                        [@fadeIn]>
                                        <span>
                                            {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                                        </span>
                                        <div class="lista-actions">
                                            <fa-icon class="card__header__icon lista-btn-close" size="2x"
                                                (click)="removeFileDocument('documentoRescisao',i)"
                                                [icon]="faSquareXmark">
                                            </fa-icon>
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 px-2">
                                <form-input
                                    [errorRequired]="(formDocumentos.get('documentoRecisao.file')?.touched && formDocumentos.get('documentoRecisao.file')?.value == null)"
                                    [labelInput]="'Cópia rescisão do contrato de trabalho '" [isMultiple]="false" [isRequired]="true"
                                    [tipoDocumento]="'documentoRecisao'"
                                    (adicionar)="adicionarArquivos('documentoRecisao',$event)">
                                </form-input>
                                <section class="col-xl-12 p-0 content-form-lista">
                                    <div class="lista-row"
                                        *ngFor="let itemFile of formDocumentos.get('documentoRecisao.file')?.value; let i = index"
                                        [@fadeIn]>
                                        <span>
                                            {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                                        </span>
                                        <div class="lista-actions">
                                            <fa-icon class="card__header__icon lista-btn-close" size="2x"
                                                (click)="removeFileDocument('documentoRecisao',i)" [icon]="faSquareXmark">
                                            </fa-icon>
                                        </div>
                                    </div>
                                </section>
                            </div> -->
                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 px-2"
                                *ngIf="profile && profile?.hasBsaPermission">
                                <form-input
                                    [errorRequired]="(formDocumentos.get('documentoBsa.file')?.touched && formDocumentos.get('documentoBsa.file')?.value == null)"
                                    [labelInput]="'Cópia da comprovação do BSA '" [isMultiple]="false"
                                    [isRequired]="true" [tipoDocumento]="'bsa'"
                                    (adicionar)="adicionarArquivos('documentoBsa',$event)">
                                </form-input>
                                <section class="col-xl-12 p-0 content-form-lista">
                                    <div class="lista-row"
                                        *ngFor="let itemFile of formDocumentos.get('documentoBsa.file')?.value; let i = index"
                                        [@fadeIn]>
                                        <span>
                                            {{itemFile.fileName}} - ({{itemFile.size | number: "1.0-2" }} KB)
                                        </span>
                                        <div class="lista-actions">
                                            <fa-icon class="card__header__icon lista-btn-close" size="2x"
                                                (click)="removeFileDocument('documentoBsa',i)" [icon]="faSquareXmark">
                                            </fa-icon>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </section>
                        <h5 class="mt-3" style="width: 100%;text-align: center;">Anexo 01</h5>
                        <section class="content__aviso__artigo">
                            <div class="content-progressiva">
                                <h5>Opção pela Tabela Regressiva para a Progressiva</h5>
                                <blockquote>
                                    Destacamos que a alteração da forma de tributação para a Tabela Progressiva não
                                    implica somente nos valores descontados do seu benefício mensal ou resgate, mas ela
                                    produz
                                    também efeitos permanentes no que tange à declaração anual de Imposto de Renda.
                                    <br>
                                    Listamos abaixo pontos que merecem sua atenção:
                                </blockquote>
                                <div class="enumerated-list">
                                    <p>
                                        A opção pela Tabela Progressiva é irretratável. Não há como voltar para a Tabela
                                        Regressiva;
                                    </p>
                                    <p>
                                        Os valores recebidos pela Tabela Progressiva são rendas tributáveis e devem ser
                                        informados na sua declaração anual de IR e se somarão às demais rendas
                                        tributáveis mensais,
                                        quando então será calculado o valor real do IR;
                                    </p>
                                    <p>
                                        Sendo mais uma renda tributável, há possibilidade de lançamento de deduções como
                                        saúde, previdência, e educação sobre essa renda;
                                    </p>
                                    <p>
                                        Para os rendimentos tributados pela Tabela Progressiva haverá a aplicação de
                                        isenção de uma parcela, conforme a legislação vigente, a partir dos 65 anos de
                                        idade.
                                    </p>
                                </div>
                            </div>
                            <div class="content-regressiva">
                                <h5>Opção pela Tabela Progressiva para a Regressiva</h5>
                                <blockquote class="main-content-blockquote">
                                    Destacamos que a opção pela forma de tributação para a Tabela Regressiva não implica
                                    somente nos valores descontados do seu benefício mensal, mas ela produz também
                                    efeitos permanentes no que tange à declaração
                                    anual de Imposto de Renda.
                                    <br>
                                    Listamos abaixo pontos que merecem sua atenção:
                                </blockquote>
                                <div class="enumerated-list">
                                    <p>
                                        A opção agora, como assistido, pela Tabela Regressiva é irretratável. Não há
                                        como voltar para a Tabela Progressiva.
                                    </p>
                                    <p>
                                        Os valores recebidos pela Tabela Regressiva possuem tributação definitiva, ou
                                        seja, exclusiva na fonte e aparecerão apenas pelo valor líquido em seu informe
                                        de rendimentos;
                                    </p>
                                    <p>
                                        Os valores devem ser declarados como renda já tributada e não compõem mais sua
                                        renda anual tributável na declaração de Imposto de Renda.
                                    </p>
                                    <p>
                                        Não sendo mais uma tributável, não há possibilidade de lançamento de deduções
                                        como saúde, previdência e educação sobre essa renda;
                                    </p>
                                    <p>
                                        As eventuais deduções, na declaração de imposto de renda, poderão ser efetuadas
                                        somente nos valores recebidos pelo INSS, BSA (para quem tem esse complemento) e
                                        outras fontes de renda;
                                    </p>
                                    <p>
                                        Havendo geração de pensão para seus dependentes, eles estão obrigados a
                                        permanecer na Tabela Regressiva, sem a opção de escolha.
                                    </p>
                                    <p>
                                        Para os rendimentos tributados pela Tabela Regressiva não haverá isenção de
                                        parcela, conforme a legislação vigente, a partir dos 65 anos de idade, como
                                        ocorre com a Tabela Progressiva.
                                    </p>
                                </div>
                            </div>
                        </section>
                        <div class="aviso-resgate mb-2">
                            <p>Conforme dispõe a Lei 11.053/05, alterada pela Lei 14.803/24, a opção pelo regime de
                                tributação poderá ser exercida até o momento da obtenção do benefício previdenciário.
                            </p>
                            <br>
                            <p>Conforme legislação vigente e orientações do <b>Anexo 01</b>, formalizo minha opção
                                tributária conforme abaixo:</p>
                        </div>
                        <section class="row formularioInstituto-content-checkbox">
                            <div class="form-check mr-2">
                                <input class="form-check-input" type="radio" name="exampleRadios"
                                    id="tributacao-regressiva-integral-true" value="Progressiva"
                                    formControlName="tributacao">
                                <label class="form-check-label" for="tributacao-regressiva-integral-true">
                                    Tributação pela tabela <b>Progressiva</b>
                                </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="exampleRadios"
                                    id="tributacao-regressiva-integral-false" value="Regressiva"
                                    formControlName="tributacao">
                                <label class="form-check-label" for="tributacao-regressiva-integral-false">
                                    Tributação pela tabela <b>Regressiva</b>
                                </label>
                            </div>
                        </section>
                        <div class="form-check form-check-inline col-12 py-3">
                            <input class="form-check-input" type="checkbox" id="check-box-instituto-selecionado"
                                value="true" formControlName="aceite">
                            <label class="form-check-label label-form"
                                for="check-box-instituto-selecionado">Concordo</label>
                        </div>
                    </section>
                    <section
                        *ngIf="formInstituido.get('instituido')?.value == 14 || formInstituido.get('instituido')?.value == 15">
                        <h5 class="mt-2" style="width: 100%;text-align: center;">Anexo 01</h5>
                        <p class="aviso-resgate">
                            <b>Importante</b>: Primeiramente, a Fundação Copel destaca que em caso de resgate parcial, a
                            opção pela forma de tributação será definitiva, sendo aplicada nos futuros pagamentos de
                            reserva parcial, total ou benefício previdenciário.
                        </p>
                        <section class="content__aviso__artigo">
                            <div class="content-progressiva">
                                <h5>Opção pela Tabela Progressiva:</h5>
                                <blockquote class="main-content-blockquote">
                                    Destacamos que a opção pela forma de tributação para a Tabela Progressiva não
                                    implica somente nos valores descontados do seu resgate, mas ela produz também
                                    efeitos permanentes no que tange à declaração anual de Imposto de Renda. Listamos
                                    abaixo pontos que merecem sua atenção:
                                </blockquote>
                                <div class="enumerated-list">
                                    <p>
                                        O resgate, pela Tabela Progressiva, possui tributação na fonte de 15%. Contudo,
                                        o valor resgatado é uma renda tributável e deve ser informado na sua declaração
                                        anual de IR e se somará às demais rendas tributáveis mensais, quando então será
                                        calculado o valor real do IR;
                                    </p>
                                    <p>
                                        Sendo mais uma renda tributável, há possibilidade de lançamento de deduções como
                                        saúde, previdência e educação sobre essa renda na declaração anual.
                                    </p>
                                </div>
                            </div>
                            <div class="content-regressiva">
                                <h5>Opção pela Tabela Regressiva:</h5>
                                <blockquote class="main-content-blockquote">
                                    Destacamos que a opção pela forma de tributação para a Tabela Regressiva não implica
                                    somente nos valores descontados do seu resgate, mas ela produz também efeitos
                                    permanentes no que tange à declaração anual de Imposto de Renda. Listamos abaixo
                                    pontos que merecem sua atenção:
                                </blockquote>
                                <div class="enumerated-list">
                                    <p>
                                        Os valores recebidos pela Tabela Regressiva possuem tributação definitiva, ou
                                        seja, exclusiva na fonte e aparecerão apenas pelo valor líquido em seu informe
                                        de rendimentos;
                                    </p>
                                    <p>
                                        Os valores devem ser declarados como renda já tributada e não compõe mais sua
                                        renda anual tributável na declaração de Imposto de Renda;
                                    </p>
                                    <p>
                                        Não sendo mais uma renda tributável, não há possibilidade de lançamento de
                                        deduções como saúde, previdência e educação sobre essa renda;
                                    </p>
                                    <p>
                                        As eventuais deduções, na declaração de imposto de renda, poderão ser efetuadas
                                        somente nos valores recebidos pelo INSS e outras fontes de renda;
                                    </p>
                                </div>
                            </div>
                        </section>
                        <div class="aviso-resgate mb-2">
                            <p>Conforme dispõe a Lei 11.053/05, alterada pela Lei 14.803/24, a opção pelo regime de
                                tributação poderá ser exercida até o momento da obtenção do resgate Total ou Parcial.
                                Segundo a legislação descrita acima, formalizo minha opção tributária conforme abaixo:
                            </p>
                        </div>
                        <section class="row formularioInstituto-content-checkbox">
                            <div class="form-check mr-2">
                                <input class="form-check-input" type="radio" name="exampleRadios"
                                    id="tributacao-regressiva-integral-true" value="Progressiva"
                                    formControlName="tributacao">
                                <label class="form-check-label" for="tributacao-regressiva-integral-true">
                                    Tributação pela tabela <b>Progressiva</b>
                                </label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="exampleRadios"
                                    id="tributacao-regressiva-integral-false" value="Regressiva"
                                    formControlName="tributacao">
                                <label class="form-check-label" for="tributacao-regressiva-integral-false">
                                    Tributação pela tabela <b>Regressiva</b>
                                </label>
                            </div>
                        </section>
                        <p class="mt-3 mb-3" style="font-size: 0.875rem;">
                            <b>Obs.:</b> Em caso de dúvida consulte o seu contador, que melhor poderá orientá-la sobre a
                            melhor escolha para sua opção.
                        </p>
                        <div class="form-check form-check-inline col-12 py-3">
                            <input class="form-check-input" type="checkbox" id="check-box-instituto-selecionado"
                                value="true" formControlName="aceite">
                            <label class="form-check-label label-form"
                                for="check-box-instituto-selecionado">Concordo</label>
                        </div>
                    </section>
                </form>
                <div class="content-stepper-buttons mt-3">
                    <button class="btn btn-outline-primary" mat-button matStepperPrevious>Voltar</button>
                    <button class="btn btn-primary" mat-button matStepperNext
                        [disabled]="!formDocumentos.valid">Próximo</button>
                </div>
            </mat-step>
            <mat-step [stepControl]="formSaude"
                *ngIf="user.healthProfile && user.healthProfile?.description && user.healthProfile?.hasDependants == true">
                <ng-template matStepLabel>Saúde -
                    <b>({{user.healthProfile?.description.toUpperCase()}})</b>
                    <!-- <ng-template *ngIf="beneficiaries">({{ beneficiaries[0]?.healthInsuranceName }})</ng-template> -->
                </ng-template>
                <form [formGroup]="formSaude">
                    <blockquote class="main-content-blockquote">
                        Caso o titular queira realizar o cancelamento de seu plano de saúde ou a exclusão de algum
                        dependente deverá realizar a solicitação no Você no Controle, no menu Plano de Saúde - Opção
                        Cancelar Plano de Saúde ou Excluir Dependente do Plano.
                        A portabilidade de carências poderá ser solicitada pelo beneficiário Titular durante ou após o
                        término do período do PDV, <b>porém uma vez cancelado o plano, a carta não poderá ser
                            emitida</b>.
                    </blockquote>
                    <p class="p-2" style="font-size: 0.875rem; margin-bottom: 1rem;" (click)="redirectTo('')">
                        Grupo Familiar do Plano de Saúde
                    </p>
                    <section class="mb-2 content-prosaude" *ngFor="let beneficiary of beneficiaries">
                        <div>
                            <span>Vinculo de Dependência:</span>
                            <span>{{beneficiary.tipo}}</span>
                        </div>
                        <div>
                            <span>Nome:</span>
                            <span>{{beneficiary.name}}</span>
                        </div>
                        <div>
                            <span>Data de Nascimento:</span>
                            <span>{{beneficiary.nascimento | date:'dd-MM-yyyy'}}</span>
                        </div>
                        <div>
                            <span>CNS:</span>
                            <span>{{beneficiary.nationalHealthCard}}</span>
                        </div>
                        <div>
                            <span>Patrocinadora:</span>
                            <span>{{beneficiary.company}}</span>
                        </div>
                    </section>
                    <div class="form-check form-check-inline col-12 py-3">
                        <input class="form-check-input" type="checkbox" id="check-box-pro-saude" value="true"
                            formControlName="aceite">
                        <label class="form-check-label label-form" for="check-box-pro-saude">Concordo</label>
                    </div>
                </form>
                <div class="content-stepper-buttons">
                    <button class="btn btn-outline-primary" mat-button matStepperPrevious>Voltar</button>
                    <button class="btn btn-primary" mat-button matStepperNext
                        [disabled]="!formSaude.valid">Próximo</button>
                </div>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Revise os Dados</ng-template>
                <h6 class="mt-3 mb-1 sub-title-revisao" id="finalizacao">Dados Pessoais</h6>
                <section class="row content-revisao content-card-revisao">
                    <div class="px-1 col-xl-4 col-lg-6">
                        <span>Nome:</span>
                        <span>{{meusDados.get('name')?.value}}</span>
                    </div>
                    <div class="px-1 col-xl-3 col-lg-3">
                        <span>Matrícula:</span>
                        <span>{{meusDados.get('registration')?.value}}</span>
                    </div>
                    <div class="px-1 col-xl-3 col-lg-3">
                        <span>CPF:</span>
                        <span>{{meusDados.get('cpf')?.value | cpfCnpj}}</span>
                    </div>
                </section>
                <h6 class="mt-3 mb-1 sub-title-revisao" id="finalizacao"
                    *ngIf="user.healthProfile && user.healthProfile?.description">Dados de Saúde</h6>
                <section class="content-revisao-saude content-revisao content-card-revisao"
                    *ngIf="user.healthProfile && user.healthProfile?.description">
                    <section class="row">
                        <div class="px-1 col-xl-4 col-lg-6">
                            <span style="font-weight: 500; margin-right: 0.25rem;">Meu Plano:</span>
                            <span>{{user.healthProfile?.description.toUpperCase()}}</span>
                        </div>
                        <div class="px-1 col-xl-3 col-lg-3">
                            <span style="font-weight: 500; margin-right: 0.25rem;">Status do Plano:</span>
                            <span>{{user.healthProfile?.statusDescription}}</span>
                        </div>
                    </section>
                    <section>
                        <span style="font-weight: 500; margin-left: 0.25rem;">Inscrito(s) no meu Plano de Saúde:</span>
                        <ol style="font-size: 0.8rem; line-height: 1.313rem;">
                            <li *ngFor="let beneficiary of beneficiaries">
                                {{beneficiary.name}}
                            </li>
                        </ol>
                    </section>
                </section>
                <h6 class="mt-3 mb-1 sub-title-revisao">Endereço</h6>
                <section class="row content-revisao content-card-revisao">
                    <div class="px-1 col-xl-3 col-lg-3">
                        <span>Cep:</span>
                        <span>{{ formContact.get('cep')?.value || 'Não informado' }}</span>
                    </div>
                    <div class="px-1 col-xl-6 col-lg-6">
                        <span>Endereço:</span>
                        <span>{{ formContact.get('address')?.value || 'Não informado' }}</span>
                    </div>
                    <div class="px-1 col-xl-2 col-lg-2">
                        <span>Número:</span>
                        <span>{{ formContact.get('number')?.value || 'Não informado' }}</span>
                    </div>
                    <div class="px-1 col-xl-3 col-lg-3">
                        <span>Complemento:</span>
                        <span>{{ formContact.get('complement')?.value || 'Não informado' }}</span>
                    </div>
                    <div class="px-1 col-xl-3 col-lg-3">
                        <span>Bairro:</span>
                        <span>{{ formContact.get('district')?.value || 'Não informado' }}</span>
                    </div>
                    <div class="px-1 col-xl-3 col-lg-3">
                        <span>Caixa Postal:</span>
                        <span>{{ formContact.get('postalCode')?.value || 'Não informado' }}</span>
                    </div>
                    <div class="px-1 col-xl-2 col-lg-2">
                        <span>Município:</span>
                        <span>{{ formContact.get('city')?.value || 'Não informado' }}</span>
                    </div>
                    <div class="px-1 col-xl-2 col-lg-2">
                        <span>UF:</span>
                        <span>{{ formContact.get('state')?.value || 'Não informado' }}</span>
                    </div>
                    <div class="px-1 col-xl-2 col-lg-2">
                        <span>País:</span>
                        <span>{{ formContact.get('country')?.value || 'Não informado' }}</span>
                    </div>
                    <div class="px-1 col-xl-3 col-lg-3">
                        <span>Telefone Celular:</span>
                        <span>{{ formContact.get('personalPhone')?.value | Phone }}</span>
                    </div>
                    <div class="px-1 col-xl-3 col-lg-3">
                        <span>Telefone Comercial/Residencial:</span>
                        <span>{{ formContact.get('comercialPhone')?.value | Phone }}</span>
                    </div>
                    <div class="px-1 col-xl-3 col-lg-3">
                        <span>E-mail:</span>
                        <span>{{ formContact.get('email')?.value || 'Não informado' }}</span>
                    </div>
                    <div class="px-1 col-xl-3 col-lg-3">
                        <span>E-mail alternativo:</span>
                        <span>{{ formContact.get('secondaryEmail')?.value || 'Não informado' }}</span>
                    </div>
                </section>
                <div class="col-12 px-1 mt-2 mb-2"
                    style="font-size: 0.8rem; color: #D25401; font-weight: 500; margin-top: 1rem !important; margin-bottom: 1rem !important; background: #F9D3BA; padding: 0.875rem 0.75rem; border-radius: 3px;"
                    *ngIf="formContact.get('replicateDependant')?.value == true">
                    Você escolheu replicar os endereços para seus dependentes
                </div>
                <h6 class="mt-3 mb-1 sub-title-revisao">Dados Bancários</h6>
                <section class="row content-revisao content-card-revisao" *ngIf="dataBanco">
                    <div class="px-1 col-xl-6 col-lg-6">
                        <span>Nome do Banco:</span>
                        <span>{{dataBanco.banco || 'Não localizado'}}</span>
                    </div>
                    <div class="px-1 col-xl-6 col-lg-6">
                        <span>Número da Conta:</span>
                        <span>{{dataBanco.conta || 'Não localizado'}}</span>
                    </div>
                    <div class="px-1 col-xl-6 col-lg-6">
                        <span>Tipo de Conta:</span>
                        <span>{{dataBanco.tipo_Conta || 'Não localizado'}}</span>
                    </div>
                    <div class="px-1 col-xl-6 col-lg-6">
                        <span>Número da Agência:</span>
                        <span>{{dataBanco.agencia || 'Não localizado' }}</span>
                    </div>
                </section>
                <p class="alerta-titulo-revisao"
                    style="font-size: 0.8rem; color: #D25401; font-weight: 500; margin-top: 1rem !important; margin-bottom: 1rem !important; background: #F9D3BA; padding: 0.875rem 0.75rem; border-radius: 3px;"
                    *ngIf="listaDocumentos.length > 0">
                    Você solicitou a Alteração dos dados Bancários
                </p>
                <section class="col-xl-12 p-0 content-form-lista content-form-lista-resultado"
                    *ngIf="listaDocumentos.length > 0">
                    <div class="lista-row" *ngFor="let file of listaDocumentos; let i = index">
                        <span>
                            {{file.fileName}}
                        </span>
                        <div class="lista-actions">
                            <!-- <fa-icon class="card__header__icon lista-btn-close" size="2x"
                                (click)="removeFile(i)" [icon]="faSquareXmark">
                            </fa-icon> -->
                        </div>
                    </div>
                </section>
                <h6 class="mt-3 mb-1 sub-title-revisao">Dependentes de IR selecionado(s)</h6>
                <ng-template #dependenteNaoSelecionado>
                    <p style="padding: 0.5rem;font-size: 0.875rem;">Você não selecionou nenhum dependente!</p>
                </ng-template>
                <section class="content-card-revisao">
                    <section class="content-revisao content-resultado-dependentes-ir"
                        *ngIf="listaDependentesIr && listaDependentesIr.length > 0 else dependenteNaoSelecionado">
                        <p *ngFor="let dependente of listaDependentesIr">
                            {{dependente.name}} - {{dependente.familyType}}
                        </p>
                    </section>
                </section>
                <h6 class="mt-3 mb-1 sub-title-revisao">Opção Escolhido</h6>
                <section class="row content-revisao content-card-revisao">
                    <div class="px-1 col-xl-6 col-lg-6 row">
                        <span>Opção:</span>
                        <span>
                            <p *ngIf="formInstituido.get('instituido')?.value == 1">Aposentadoria </p>
                            <p *ngIf="formInstituido.get('instituido')?.value == 10"> Autopatrocínio </p>
                            <p *ngIf="formInstituido.get('instituido')?.value == 11"> Benefício Proporcional Diferido -
                                (BPD) </p>
                            <p *ngIf="formInstituido.get('instituido')?.value == 12"> Portabilidade Integral </p>
                            <p *ngIf="formInstituido.get('instituido')?.value == 13"> Portabilidade Parcial </p>
                            <p *ngIf="formInstituido.get('instituido')?.value == 14"> Resgate Integral </p>
                            <p *ngIf="formInstituido.get('instituido')?.value == 15"> Resgate Parcial</p>
                            <p *ngIf="formInstituido.get('instituido')?.value == 16"> Benefício de pagamento único (BPU)
                            </p>
                        </span>
                    </div>
                    <div class="px-1 col-xl-6 col-lg-6 row"
                        *ngIf="formDocumentos.get('adicionalBeneficio')?.value != null">
                        <span>Benefício:</span>
                        <span>
                            <p *ngIf="formDocumentos.get('adicionalBeneficio')?.value === 'true'">Com adicional de
                                benefício de risco</p>
                            <p *ngIf="formDocumentos.get('adicionalBeneficio')?.value === 'false'">Sem adicional de
                                benefício de risco</p>
                        </span>
                    </div>
                    <div class="px-1 col-xl-6 col-lg-6 row"
                        *ngIf="possuiPeculio == true && formInstituido.get('instituido')?.value == 10 && formInstituido.get('instituido')?.value == 11">
                        <span>Permanecer com Plano Pecúlio:</span>
                        <span>
                            <p *ngIf="formDocumentos.get('interessePermanencia')?.value === 'true'">Sim</p>
                            <p *ngIf="formDocumentos.get('interessePermanencia')?.value === 'false'">Não</p>
                        </span>
                    </div>
                    <div class="px-1 col-xl-6 col-lg-6 row"
                        *ngIf="formDocumentos.get('portabilidadeOuResgateParcial')?.value != null && formInstituido.get('instituido')?.value == 13">
                        <span>Portabilidade Parcial:</span>
                        <span>
                            <p *ngIf="formDocumentos.get('portabilidadeOuResgateParcial')?.value == 'EAPC' ">
                                Portabilidade Oriunda de EAPC</p>
                            <p *ngIf="formDocumentos.get('portabilidadeOuResgateParcial')?.value == 'EFPC' ">
                                Portabilidade oriunda de EFPC (Somente parte do participante)</p>
                            <p
                                *ngIf="formDocumentos.get('portabilidadeOuResgateParcial')?.value == 'FacultativasEOuAportes' ">
                                Contribuições facultativas e/ou aportes</p>
                        </span>
                    </div>
                    <div class="px-1 col-xl-6 col-lg-6 row"
                        *ngIf="formDocumentos.get('quantidadeParcelas')?.value != null">
                        <span>Forma de Pagamento:</span>
                        <span>
                            <p *ngIf="formDocumentos.get('quantidadeParcelas')?.value == '1' ">Parcela Única</p>
                            <p *ngIf="formDocumentos.get('quantidadeParcelas')?.value != '1' ">Parcelado em
                                {{formDocumentos.get('quantidadeParcelas')?.value}} vezes</p>
                        </span>
                    </div>
                    <div class="px-1 col-xl-6 col-lg-6 row"
                        *ngIf="formDocumentos.get('portabilidadeOuResgateParcial')?.value != null && formInstituido.get('instituido')?.value == 15">
                        <span>Desejo Realizar o resgate parcial em:</span>
                        <span>
                            <p *ngIf="formDocumentos.get('portabilidadeOuResgateParcial')?.value == 'EAPC' ">
                                Portabilidade oriunda de EAPC</p>
                            <p *ngIf="formDocumentos.get('portabilidadeOuResgateParcial')?.value == 'EFPC' ">
                                Portabilidade oriunda de EFPC</p>
                            <p
                                *ngIf="formDocumentos.get('portabilidadeOuResgateParcial')?.value == 'FacultativasEOuAportes' ">
                                Contribuições facultativas e/ou aportes</p>
                        </span>
                    </div>
                    <div class="px-1 col-xl-6 col-lg-6 row" *ngIf="formDocumentos.get('tributacao')?.value != null">
                        <span>Tributação:</span>
                        <span>
                            <p *ngIf="formDocumentos.get('tributacao')?.value === 'Progressiva' ">Tributação pela tabela
                                Progressiva</p>
                            <p *ngIf="formDocumentos.get('tributacao')?.value == 'Regressiva' ">Tributação pela tabela
                                Regressiva</p>
                        </span>
                    </div>
                </section>
                <div class="form-check form-check-inline col-12 py-3">
                    <input class="form-check-input" type="checkbox" name="check-box-finalizar" id="check-box-instituto"
                        value="true" [(ngModel)]="aceiteFinalizar">
                    <label class="form-check-label label-form" for="check-box-finalizar">Concordo</label>
                </div>
                <div class="content-stepper-buttons">
                    <button class="btn btn-outline-primary" mat-button matStepperPrevious>Voltar</button>
                    <button class="btn btn-primary" mat-button (click)="salvar()"
                        [disabled]="!aceiteFinalizar || this.loadingCosts">
                        <div class="d-flex" *ngIf="loadingCosts; else showSpan">
                            <span class="spinner">
                            </span>
                        </div>
                        <ng-template #showSpan>
                            <span>Finalizar</span>
                        </ng-template>
                    </button>
                </div>
            </mat-step>
        </mat-vertical-stepper>
    </section>
</main>